var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.334 13.6667H4.66732C2.66732 13.6667 1.33398 12.6667 1.33398 10.3333V5.66668C1.33398 3.33334 2.66732 2.33334 4.66732 2.33334H11.334C13.334 2.33334 14.6673 3.33334 14.6673 5.66668V10.3333C14.6673 12.6667 13.334 13.6667 11.334 13.6667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9992 8.58001C7.4392 8.58001 6.87254 8.40668 6.4392 8.05334L4.35253 6.38668C4.1392 6.21334 4.0992 5.90001 4.27254 5.68668C4.44587 5.47334 4.75921 5.43335 4.97254 5.60668L7.0592 7.27335C7.56587 7.68001 8.42586 7.68001 8.93253 7.27335L11.0192 5.60668C11.2325 5.43335 11.5525 5.46668 11.7192 5.68668C11.8925 5.90001 11.8592 6.22001 11.6392 6.38668L9.55254 8.05334C9.12587 8.40668 8.5592 8.58001 7.9992 8.58001Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.d57e64b327e354c9c6ae03b82e218208.svg";
export { ForwardRef as ReactComponent };